<template>
	<div class="tab-pane fade active show">
		<div class="row justify-content-center">
			<div class="col-md-10 col-lg-8">
				<div class="row mb-4">
					<div class="col">
						<form v-if="dataResume" @submit.prevent="validateBeforeSubmit">
							<div class="form-row">
								<div class="col-sm-6">
									<div class="form-group field-profileform-name">
										<label class="control-label" for="profileform-name">{{labels.first_name}}
										</label>
										<input type="text" id="profileform-name" class="form-control" v-model="resume.first_name">
										<div v-show="err.first_name">{{err.first_name}}</div>
									</div>
								</div>
								<div class="col-sm-6">
									<div class="form-group field-profileform-second_name">
										<label class="control-label" for="profileform-second_name">
											{{labels.last_name}}
										</label>
										<input type="text" id="profileform-second_name" class="form-control" v-model="resume.last_name">
										<div v-show="err.last_name">{{err.last_name}}</div>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="col">
									<div class="form-group field-profileform-middle_name">
										<label class="control-label" for="profileform-middle_name">
											{{labels.middle_name}}
										</label>
										<input type="text"
												id="profileform-middle_name"
												class="form-control"
												name="middle_name"
												v-model="resume.middle_name"
										>
										<div v-show="err.middle_name">{{err.middle_name}}</div>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="col-sm-6">
									<div class="form-group field-profileform-email">
										<label class="control-label">{{labels.birthday}}</label>
										<datepicker type="text"
												id="profileform-birthday"
												:input-class="'form-control'"
												name="birthday"
												:value="birthday"
												:language="ru"
												:initial-view="'year'"
												format="dd.MM.yyyy"
												@input="resume.birthday = fixDate($event)"
										></datepicker>
										<div v-show="err.hasOwnProperty('birthday')">{{err.birthday}}</div>
									</div>
								</div>
								<div class="col-sm-6">
									<div class="form-group field-profileform-phone">
										<label class="control-label" for="profileform-phone">Телефон</label>
										<input type="text" id="profileform-phone" class="form-control" v-mask="'8(###)###-##-##'" v-model="resume.phone" placeholder="8(___)___-__-__">
										<div v-show="err.phone">{{err.phone}}</div>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="col-sm-6">
									<div class="form-group field-profileform-search">
										<label class="control-label" for="profileform-search">{{labels.search}}</label>
										<input type="text"
												id="profileform-search"
												class="form-control"
												name="birthday"
												v-model="resume.search"
										>
										<div v-show="err.hasOwnProperty('search')">{{err.search}}</div>
									</div>
								</div>
								<div class="col-sm-6">
									<div class="form-group field-profileform-search_list">
										<label class="control-label" for="profileform-search_list">
											{{labels.search_list}}
										</label>
										<input type="text" id="profileform-search_list" class="form-control" v-model="resume.search_list">
										<div v-show="err.search_list">{{err.search_list}}</div>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="col">
									<label class="control-label">{{labels.gender}}</label>
									<div class="form-group field-gender mb-3 mt-1">
										<label class="radio mr-2" v-for="(radioItem, index) in genderList">
											<input type="radio"
													name="gender"
													:value=index
													v-model="resume.gender"
												>
											<span class="radio__circle"></span>
											<span>{{radioItem}}</span>
										</label>
										<div v-show="err.gender">{{err.gender}}</div>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="col-sm-6">
									<div class="form-group">
										<label class="control-label" for="profileform-city">{{labels.city}}</label>
										<input type="text"
												id="profileform-city"
												class="form-control"
												name="city"
												v-model="resume.city"
										>
										<div v-show="err.hasOwnProperty('city')">{{err.city}}</div>
									</div>
								</div>
								<div class="col-sm-6">
									<div class="form-group">
										<label class="control-label" for="profileform-metro">
											{{labels.metro}}
										</label>
										<vue-bootstrap-typeahead
												id="profileform-metro"
												:data="metroList"
												v-model="resume.metro"
												:serializer="s => s"
										/>
										<div v-show="err.metro">{{err.metro}}</div>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="col-sm-6">
									<div class="form-group">
										<label class="control-label" for="profileform-payment">{{labels.payment}}</label>
										<input type="text"
												id="profileform-payment"
												class="form-control"
												name="city"
												v-model="resume.payment"
										>
										<div v-show="err.hasOwnProperty('payment')">{{err.payment}}</div>
									</div>
								</div>
								<div class="col-sm-6">
									<div class="form-group">
										<label class="control-label" for="profileform-experience">
											{{labels.experience}}
										</label>
										<input type="text" id="profileform-experience" class="form-control" v-model="resume.experience" placeholder="Укажите кол-во месяцев цифрой">
										<div v-show="err.experience">{{err.experience}}</div>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="col-sm-6">
									<label class="control-label">{{labels.schedule}}</label>
									<div class="form-group mb-3 mt-1">
										<label class="checkbox mr-2" v-for="(radioItem, index) in scheduleList">
											<input type="checkbox"
													:name="'schedule[' + index + ']'"
													:value=index
													v-model="resume.schedule"
											>
											<span class="checkbox__circle"></span>
											<span>{{radioItem}}</span>
										</label>
										<div v-show="err.hasOwnProperty('schedule')">{{err.schedule}}</div>
									</div>
								</div>
								<div class="col-sm-6">
									<div class="form-group">
										<label class="control-label">
											{{labels.employment}}
										</label>
										<div class="form-group field-employment mb-3 mt-1">
											<label class="checkbox mr-2" v-for="(radioItem, index) in employmentList">
												<input type="checkbox"
														:name="'employment[' + index + ']'"
														:value=index
														v-model="resume.employment"
												>
												<span class="checkbox__circle"></span>
												<span>{{radioItem}}</span>
											</label>
											<div v-show="err.employment">{{err.employment}}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="col">
									<div class="form-group">
										<label class="control-label" for="profileform-experience_text">{{labels.experience_text}}</label>
										<textarea type="text"
												id="profileform-experience_text"
												class="form-control"
												name="schedule"
												rows="6"
												v-model="resume.experience_text"
												placeholder="Укажите данные о вашем опыте работы"
										></textarea>
										<div v-show="err.hasOwnProperty('experience_text')">{{err.experience_text}}</div>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="col-sm-6">
									<div class="form-group">
										<label class="control-label" for="profileform-last_job">{{labels.last_job}}</label>
										<input type="text"
												id="profileform-last_job"
												class="form-control"
												name="last_job"
												v-model="resume.last_job"
										>
										<div v-show="err.hasOwnProperty('schedule')">{{err.last_job}}</div>
									</div>
								</div>
								<div class="col-sm-6">
									<div class="form-group">
										<label class="control-label" for="profileform-last_position">
											{{labels.last_position}}
										</label>
										<input type="text" id="profileform-last_position" class="form-control" v-model="resume.last_position">
										<div v-show="err.last_position">{{err.last_position}}</div>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="col">
									<label class="control-label">{{labels.auto}}</label>
									<div class="form-group field-auto mb-3 mt-1">
										<label class="radio mr-2" v-for="(radioItem, index) in {1: 'Есть', 0: 'Нет'}">
											<input type="radio"
													name="auto"
													:value=index
													v-model="resume.auto"
											>
											<span class="radio__circle"></span>
											<span>{{radioItem}}</span>
										</label>
										<div v-show="err.auto">{{err.auto}}</div>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="col">
									<label class="control-label">{{labels.moving}}</label>
									<div class="form-group field-moving mb-3 mt-1">
										<label class="radio mr-2" v-for="(radioItem, index) in yesNo">
											<input type="radio"
													name="moving"
													:value=index
													v-model="resume.moving"
											>
											<span class="radio__circle"></span>
											<span>{{radioItem}}</span>
										</label>
										<div v-show="err.moving">{{err.moving}}</div>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="col">
									<label class="control-label">{{labels.business_trip}}</label>
									<div class="form-group field-business_trip mb-3 mt-1">
										<label class="radio mr-2" v-for="(radioItem, index) in yesNo">
											<input type="radio"
													name="business_trip"
													:value=index
													v-model="resume.business_trip"
											>
											<span class="radio__circle"></span>
											<span>{{radioItem}}</span>
										</label>
										<div v-show="err.business_trip">{{err.business_trip}}</div>
									</div>
								</div>
							</div>

							<b-alert v-if="updated" variant="success" show dismissible>Резюме успешно сохранено</b-alert>
							<div class="form-row mt-1 align-items-center">
								<div class="col-3">
									<button type="submit" class="btn btn-secondary">Сохранить</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapFields} from 'vee-validate';
	import {mapGetters, mapActions} from 'vuex';
	import Datepicker from 'vuejs-datepicker';
	import {ru} from 'vuejs-datepicker/dist/locale';
	import moment from 'moment';
	import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

	export default {
		name: "ProfileResume",
		components: {Datepicker, VueBootstrapTypeahead},
		data() {
			return {
				ru: ru,
				labels: {
					'first_name': 'Имя',
					'middle_name': 'Отчество',
					'last_name': 'Фамилия',
					'birthday': 'День рождения',
					'search': 'Ищет работу',
					'search_list': 'Ищет работу на должность',
					'gender': 'Пол',
					'city': 'Город',
					'metro': 'Метро',
					'phone': 'Телефон',
					'payment': 'Сумма желаемого оклада',
					'employment': 'Занятость',
					'schedule': 'График работы',
					'experience': 'Опыт работы мерчандайзером/аудитором',
					'experience_text': 'Опыт работы (описание)',
					'last_job': 'Последенее/нынешнее место работы',
					'last_position': 'Последеняя/нынешняя должность',
					'auto': 'Водительские права',
					'moving': 'Переезд',
					'business_trip': 'Коммандировки',
				},
				birthday: '',
				metroList: [],
				resume: {
					first_name: '',
					middle_name: '',
					last_name: '',
					birthday: '',
					search: '',
					search_list: '',
					gender: '',
					city: '',
					metro: '',
					phone: '',
					payment: '',
					employment: [],
					schedule: [],
					experience: '',
					experience_text: '',
					last_job: '',
					last_position: '',
					auto: '',
					moving: '',
					business_trip: '',
				},
				employmentList: {
					0: 'полная занятость',
					1: 'частичная занятость',
					2: 'проектная работа',
					3: 'волонтерство',
					4: 'стажировка',
				},
				scheduleList: {
					0: 'полный день',
					1: 'вахтовый метод',
					2: 'удаленная работа',
					3: 'гибкий график',
					4: 'сменный график',
				},
				genderList: {
					1: 'Мужской',
					2: 'Женский'
				},
				yesNo: {
					1: 'Да',
					0: 'Нет'
				},
				err: {},
				updated: false
			}
		},
		methods: {
			validateBeforeSubmit() {
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.UPDATE_RESUME_DATA(this.resume)
							.then(data => {
								if (data.body.hasOwnProperty('error')) {
									this.err = data.body.error;
								}
								this.updated = data.ok;
							});
					}
				});
			},
			fixDate(e) {
				return moment(e).format('DD.MM.YYYY');
			},
			loadMetroList(city, query) {
				this.METRO_LIST({city: city, q:query}).then(res => {
					const resultArray = [];
					for(let key in res.body){
						resultArray.push(res.body[key])
					}

					this.metroList = resultArray;
				});
			},
			...mapActions({
				UPDATE_RESUME_DATA: 'resume/UPDATE_RESUME_DATA',
				GET_RESUME: 'resume/RESUME',
				METRO_LIST: 'lists/METRO_LIST',
			})
		},
		computed: {
			...mapGetters({
				dataResume: 'resume/dataResume'
			})
		},
		created() {
			this.GET_RESUME().then(res => {
				for (let key in this.dataResume) {
					if (this.resume.hasOwnProperty(key)) {
						if (key == 'birthday') {
							this.resume[key] = moment.unix(this.dataResume[key]).format('DD.MM.YYYY');
							this.birthday = moment.unix(this.dataResume[key]).format('YYYY-MM-DD');
						} else {
							this.resume[key] = this.dataResume[key];
						}
					}
				}
			}).catch(e => {console.log(e)});
		},
		watch: {
			'resume.metro': _.debounce(function(addr) { this.loadMetroList(this.resume.city, addr) }, 500)
		}
	}
</script>

<style scoped>

</style>
